export default "__VITE_ASSET__XVpAZF1orzj7PEuue70C4Q__";